import React from 'react'
import { Button, FormControlLabel, Grid, Switch, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'

// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import UserServices from '../../../../Services/Consumers/UserServices'
import { filterData } from '../../../../utils/helpers'
import { UsersFiltersPayload } from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import { NamedRoutes } from '../../../../routes'
import BreadCrumb from '../../BreadCrumb'

let { User_Config } = Configuration
export default function CompanyUsersContent ({ cid, handleNotificationCall }) {
  let classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.usersListLimit
  const [sortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)

  const columns = [
    {
      name: 'id',
      label: intl.formatMessage({ id: 'Users.List.Table.ID' }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: false
      }
    },
    {
      name: 'username',
      label: intl.formatMessage({ id: 'Users.List.Table.UserName' }),
      options: {
        filterType: 'textField',
        filter: false
      }
    },
    {
      name: 'email',
      label: intl.formatMessage({ id: 'Users.List.Table.Email' }),
      options: {
        filterType: 'textField',
        filter: false
      }
    },
    {
      name: 'phone',
      label: intl.formatMessage({ id: 'Users.List.Table.Phone' }),
      options: {
        filterType: 'textField',
        customBodyRenderLite: (dataIndex) => {
          return <div style={{ direction: 'ltr' }}>{data[dataIndex].phone}</div>
        }
      }
    },
    {
      name: 'national_id',
      label: intl.formatMessage({ id: 'Users.List.Table.NationalId' }),
      options: {
        filterType: 'textField',
        filter: false
      }
    },
    {
      name: 'role',
      label: intl.formatMessage({ id: 'CompanyHeader.UserRole' }),
      options: {
        // filterType: 'dropdown'و
        filterOptions: {
          names: ['owner', 'delegate'],
          renderValue: v => (v === 'delegate') ? intl.formatMessage({ id: 'CompanyData.UserRole.delegate' }) : intl.formatMessage({ id: 'CompanyData.UserRole.owner' })
        },
        customFilterListOptions: {
          render: v => (v === 'delegate') ? intl.formatMessage({ id: 'CompanyData.UserRole.delegate' }) : intl.formatMessage({ id: 'CompanyData.UserRole.owner' })
        }
      }
    },
    {
      name: 'active',
      label: intl.formatMessage({ id: 'CompanyHeader.UserStatus' }),
      options: {
        filterOptions: {
          names: [0, 1],
          renderValue: v => !!v ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })
        },
        customFilterListOptions: {
          render: v => !!v ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            !!tableMeta && tableMeta.rowData[0] &&
            <FormControlLabel
              label={value ? intl.formatMessage({ id: 'Users.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Users.List.Table.Active.Option.NotActive' })}
              value={value ? true : false}
              control={
                <Switch color="primary" checked={value} value={value ? true : false}/>
              }
              onChange={(event) => {
                updateValue(!JSON.parse(event.target.value))
                activateDeactivateUserCompany(tableMeta.rowData[0], !JSON.parse(event.target.value), updateValue)
              }}
            />
          )
        }
      }
    },
    {
      name: 'first_name',
      label: intl.formatMessage({ id: 'Users.List.Table.FirstName' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'last_name',
      label: intl.formatMessage({ id: 'Users.List.Table.LastName' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'country',
      label: intl.formatMessage({ id: 'Users.List.Table.Country' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'government',
      label: intl.formatMessage({ id: 'Users.List.Table.Government' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'city',
      label: intl.formatMessage({ id: 'Users.List.Table.City' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'address_line1',
      label: intl.formatMessage({ id: 'Users.List.Table.AddressLine1' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'address_line2',
      label: intl.formatMessage({ id: 'Users.List.Table.AddressLine2' }),
      options: {
        display: 'false',
        filter: false
      }
    },
    {
      name: 'contact_channel',
      label: intl.formatMessage({ id: 'Users.List.Table.HowToCommunicate' }),
      options: {
        display: 'false',
        filter: false
      }
    }
  ]

  const updateLoadedData = (uid, newActiveValue) => {
    let newData = loadedData
    newData.forEach((pageData) => {
      pageData.forEach((user) => {
        if (uid === user.id) {
          user.active = !!newActiveValue ? 1 : 0
        }
      })
    })
    setLoadedData(newData)
  }
  const activateDeactivateUserCompany = (uid, newActiveValue, updateValue) => {
    if (!!keycloak?.authenticated) {
      UserServices.activateDeactivateUserCompany(uid, cid, { 'active': newActiveValue }, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, setIsLoading).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
          updateValue(!newActiveValue)
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: newActiveValue ? 'Users.List.Table.Activate.Success' : 'Users.List.Table.Deactivate.Success' }),
              color: 'success'
            }, 'success')
            updateLoadedData(uid, newActiveValue)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
            updateValue(!newActiveValue)
          }
        }

      })

    }
  }
// get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear) => {
    if (!!keycloak?.authenticated) {

      setIsLoading(true)
      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        UserServices.getCompanyUsers(cid, {
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(UsersFiltersPayload(page, rowsPerPage, currentFilter))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
            // setUserCompaniesFailure(true)
          } else {
            if (!!result && !!result.data && !!result.data.data) {

              let newData = []
              result.data.data.forEach((user) => {
                newData.push({
                  id: user.user.id,
                  username: user.user.username,
                  email: user.user.email,
                  first_name: user.user.first_name,
                  last_name: user.user.last_name,
                  phone: user.user.phone,
                  national_id: user.user.national_id,
                  active: user.active,
                  country: user.user.country ? user.user.country.name : null,
                  government: user.user.government ? user.user.government.name : null,
                  city: user.user.city ? user.user.city.name : null,
                  address_line1: user.user.address_line1,
                  address_line2: user.user.address_line2,
                  contact_channel: user.user.contact_channel,
                  role: user.role
                })
              })
              setSortOrder(sortOrder)
              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(newData.length)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      newData = newData.sort((a, b) => {
        if (a[sortField] < b[sortField]) {
          return 1 * (sortDir === 'asc' ? -1 : 1)
        } else if (a[sortField] > b[sortField]) {
          return -1 * (sortDir === 'asc' ? -1 : 1)
        } else {
          return 0
        }
      })
    }
    setData(newData)
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
      getUsersListData(1)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('active' === columns[index].name) {
          filters[columns[index].name] = !!filterItem[0] ? 1 : 0
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }

  React.useEffect(() => {
      if (!!currentFilter) {
        xhrRequest(1, {}, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: false,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: sortOrder,
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' variant="contained" onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip') {
        setLoadedData([])
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'Users.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'Users.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Companies'/>,
          link: NamedRoutes.workspace.company.list
        }
      ]} current={<FormattedMessage id='Companies.CompanyUsers'/>}/>
      <PageTitle title={<FormattedMessage id='Sidebar.Links.Users'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true}/>}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='Users.List.Table.Title'/>
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
